import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class Emitter extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.time = this.scene.time.now;
  }

  emitSmoke () {
    this.scene.events.on(Phaser.Scenes.Events.PRE_UPDATE, this.smoke, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.smoke, this));
  }

  smoke () {
    const now = this.scene.time.now;
    const elapsed = now - this.time;
    this.time = now;

    if (elapsed > 37) {
      this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.smoke, this);
    }

    this.createSprite(UIAssetKeys._puff);

    for (let i = 0; i < this.length; i++) {
      const circle = this.getAt(i);

      circle.time += elapsed / 1000;

      if (circle.time > 0.5) {
        circle.destroy();
      }
    }
  }

  createSprite (name) {
    const sprite = ABCyaPhaser.Images.addImage(300,300, name, this).setOrigin(0);

    const global = this.getLocalPoint(this.x, this.y);
    sprite.x = -200 + global.x + Math.random() * 400;
    sprite.y = 0 + global.y + Math.random() * 150;

    sprite.speedX = 0;
    sprite.speedY = 0;
    sprite.time = 0;
    sprite.angle = 360 * Math.random();
    sprite.scale = 0.4 + Math.random() / 2;
  }
}